// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".k-tour-rewards[data-v-5ee61311]{overflow:hidden;padding:50px 0}@media screen and (max-width:959px){.k-tour-rewards[data-v-5ee61311]{padding:10px 0}}.k-tour-rewards__image[data-v-5ee61311]{height:100%!important;left:0;max-width:607px;position:absolute;top:0;width:40%!important}@media screen and (max-width:959px){.k-tour-rewards__image[data-v-5ee61311]{left:0}}", ""]);
// Exports
module.exports = exports;
